import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Button,
  Spinner,
  Form,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import toast from "react-hot-toast";
import { RestroUsers } from "../../../../services/DatabaseService/RestroUsers";

const RestroUserInfoForm = () => {
  const { apiKey } = useParams(); 
  const navigate = useNavigate();

  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isCanceling, setIsCanceling] = useState(false);

  // Validation Schema
  const validationSchema = Yup.object().shape({
    tenantName: Yup.string().required("Tenant Name is required"),
    address: Yup.string().required("Address is required"),
    country: Yup.string().required("Country is required"),
    phone: Yup.string().required("Phone Number is required"),
    validTill: Yup.date().required("Valid Till date is required"),
    regsiteredDate: Yup.date().nullable(),
    amcStartDate: Yup.date().nullable(),
    amcEndDate: Yup.date().nullable(),
    panVatNumber: Yup.string().nullable(),
    cbmsUsername: Yup.string().nullable(),
    cbmsPassword: Yup.string().nullable(),
    abbreviatedValue: Yup.string().nullable(),
  });

  

  useEffect(() => {
    console.log("use")
    console.log(apiKey)
    const fetchUserDetail = async () => {
      try {
        const response = await RestroUsers.getByApiKey(apiKey);
        console.log(apiKey)
        console.log("fired")
        console.log(response)
        formik.setValues({
          tenantName: response?.tenantName || "",
          address: response?.address || "",
          country: response?.country || "",
          phone: response?.phone || "",
          regsiteredDate: response?.regsiteredDate ? new Date(response.regsiteredDate).toISOString().split('T')[0] : "",
          validTill: response?.validTill ? new Date(response.validTill).toISOString().split('T')[0] : "",
          amcStartDate: response?.amcStartDate ? new Date(response.amcStartDate).toISOString().split('T')[0] : "",
          amcEndDate: response?.amcEndDate ? new Date(response.amcEndDate).toISOString().split('T')[0] : "",
          isDemoVersion: response?.isDemoVersion || false,
          isCloudVersion: response?.isCloudVersion || false,
          panVatNumber: response?.panVatNumber || "",
          isIRDVeriied: response?.isIRDVeriied || false,
          cbmsUsername: response?.cbmsUsername || "",
          cbmsPassword: response?.cbmsPassword || "",
          abbreviatedValue: response?.abbreviatedValue || "",
          isAbbreviated: response?.isAbbreviated || false,
          isActive: response?.isActive !== undefined ? response.isActive : true,
          apiKey: response?.apiKey || apiKey,
        });
      } catch (error) {
        console.error("Error fetching user detail:", error);
        toast.error("Failed to fetch user details");
      }
    };

    if (apiKey) {
      setIsEditing(true);
      fetchUserDetail();
    }
  }, [apiKey]);

  const formik = useFormik({
    initialValues: {
      tenantName: "",
      address: "",
      country: "",
      phone: "",
      regsiteredDate: "",
      validTill: "",
      amcStartDate: "",
      amcEndDate: "",
      isDemoVersion: false,
      isCloudVersion: false,
      panVatNumber: "",
      isIRDVeriied: false,
      cbmsUsername: "",
      cbmsPassword: "",
      abbreviatedValue: "",
      isAbbreviated: false,
      isActive: true,
      apiKey: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setIsSaving(true);

        const payload = {
          tenantName: values.tenantName,
          address: values.address,
          country: values.country,
          phone: values.phone,
          regsiteredDate: values.regsiteredDate ? new Date(values.regsiteredDate).toISOString() : new Date().toISOString(),
          validTill: new Date(values.validTill).toISOString(),
          amcStartDate: values.amcStartDate ? new Date(values.amcStartDate).toISOString() : new Date().toISOString(),
          amcEndDate: values.amcEndDate ? new Date(values.amcEndDate).toISOString() : new Date().toISOString(),
          isDemoVersion: values.isDemoVersion,
          isCloudVersion: values.isCloudVersion,
          panVatNumber: values.panVatNumber || "",
          isIRDVeriied: values.isIRDVeriied,
          cbmsUsername: values.cbmsUsername || "",
          cbmsPassword: values.cbmsPassword || "",
          abbreviatedValue: values.abbreviatedValue || "",
          isAbbreviated: values.isAbbreviated,
          isActive: values.isActive,
          apiKey: values.apiKey || "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        };

        if (isEditing) {
          await RestroUsers.update(payload);
          toast.success("Restro User Updated Successfully");
        } else {
          
          toast.info("Create functionality not yet implemented");
        }
        
        navigate("/restrousers");
      } catch (error) {
        console.error("Error:", error);
        toast.error(error?.response?.data?.message || error?.message || "Error saving restro user");
      } finally {
        setIsSaving(false);
      }
    },
  });

  const breadcrumbItems = [{ title: "Back to List", link: "/restrousers" }];

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title={isEditing ? "Edit Restro User" : "Add Restro User"}
          pageTitle="Restro Users"
          breadcrumbItems={breadcrumbItems}
        />
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={6} md={12} className="mb-3">
                      <Label for="tenantName">
                        Tenant Name: <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        id="tenantName"
                        name="tenantName"
                        placeholder="Enter tenant name"
                        value={formik.values.tenantName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.tenantName && formik.errors.tenantName}
                        readOnly
                      />
                      {formik.touched.tenantName && formik.errors.tenantName && (
                        <div className="text-danger">{formik.errors.tenantName}</div>
                      )}
                    </Col>

                    <Col lg={6} md={12} className="mb-3">
                      <Label htmlFor="address">
                        Address: <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        id="address"
                        name="address"
                        placeholder="Enter Address"
                        value={formik.values.address}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.address && formik.errors.address}
                      />
                      {formik.touched.address && formik.errors.address && (
                        <div className="text-danger">{formik.errors.address}</div>
                      )}
                    </Col>

                    <Col lg={6} md={12} className="mb-3">
                      <Label for="country">
                        Country: <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        id="country"
                        name="country"
                        placeholder="Enter Country"
                        value={formik.values.country}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.country && formik.errors.country}
                      />
                      {formik.touched.country && formik.errors.country && (
                        <div className="text-danger">{formik.errors.country}</div>
                      )}
                    </Col>

                    <Col lg={6} md={12} className="mb-3">
                      <Label for="phone">
                        Phone Number: <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        id="phone"
                        name="phone"
                        placeholder="Enter phone number"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.phone && formik.errors.phone}
                      />
                      {formik.touched.phone && formik.errors.phone && (
                        <div className="text-danger">{formik.errors.phone}</div>
                      )}
                    </Col>

                    <Col lg={6} md={12} className="mb-3">
                      <Label htmlFor="regsiteredDate">
                        Registered Date:
                      </Label>
                      <Input
                        type="date"
                        id="regsiteredDate"
                        name="regsiteredDate"
                        value={formik.values.regsiteredDate}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.regsiteredDate && formik.errors.regsiteredDate}
                        readOnly
                      />
                      {formik.touched.regsiteredDate && formik.errors.regsiteredDate && (
                        <div className="text-danger">{formik.errors.regsiteredDate}</div>
                      )}
                    </Col>

                  

                    <Col lg={6} md={12} className="mb-3">
                      <Label htmlFor="amcStartDate">
                        AMC Start Date:
                      </Label>
                      <Input
                        type="date"
                        id="amcStartDate"
                        name="amcStartDate"
                        value={formik.values.amcStartDate}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        readOnly
                      />
                    </Col>

                    <Col lg={6} md={12} className="mb-3">
                      <Label htmlFor="amcEndDate">
                        AMC End Date:
                      </Label>
                      <Input
                        type="date"
                        id="amcEndDate"
                        name="amcEndDate"
                        value={formik.values.amcEndDate}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        readOnly
                      />
                    </Col>

                    {/* <Col lg={6} md={12} className="mb-3">
                      <Label for="panVatNumber">
                        PAN/VAT Number:
                      </Label>
                      <Input
                        type="text"
                        id="panVatNumber"
                        name="panVatNumber"
                        placeholder="Enter PAN/VAT Number"
                        value={formik.values.panVatNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Col> */}

                    <Col lg={6} md={12} className="mb-3">
                      <Label for="cbmsUsername">
                        CBMS Username:
                      </Label>
                      <Input
                        type="text"
                        id="cbmsUsername"
                        name="cbmsUsername"
                        placeholder="Enter CBMS Username"
                        value={formik.values.cbmsUsername}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Col>

                    <Col lg={6} md={12} className="mb-3">
                      <Label for="cbmsPassword">
                        CBMS Password:
                      </Label>
                      <Input
                        type="password"
                        id="cbmsPassword"
                        name="cbmsPassword"
                        placeholder="Enter CBMS Password"
                        value={formik.values.cbmsPassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Col>

                    <Col lg={6} md={12} className="mb-3">
                      <Label for="abbreviatedValue">
                        Abbreviated Value:
                      </Label>
                      <Input
                        type="text"
                        id="abbreviatedValue"
                        name="abbreviatedValue"
                        placeholder="Enter Abbreviated Value"
                        value={formik.values.abbreviatedValue}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Col>

                    <Col lg={12} md={12} className="mb-3">
                      <Row>
                        <Col lg={3} md={6} className="mb-2">
                          <div className="form-check">
                            <Input
                              type="checkbox"
                              id="isActive"
                              name="isActive"
                              checked={formik.values.isActive}
                              onChange={formik.handleChange}
                              className="form-check-input"
                            />
                            <Label check htmlFor="isActive" className="form-check-label">
                              Active
                            </Label>
                          </div>
                        </Col>

                        <Col lg={3} md={6} className="mb-2">
                          <div className="form-check">
                            <Input
                              type="checkbox"
                              id="isDemoVersion"
                              name="isDemoVersion"
                              checked={formik.values.isDemoVersion}
                              onChange={formik.handleChange}
                              className="form-check-input"
                            />
                            <Label check htmlFor="isDemoVersion" className="form-check-label">
                              Demo Version
                            </Label>
                          </div>
                        </Col>

                        <Col lg={3} md={6} className="mb-2">
                          <div className="form-check">
                            <Input
                              type="checkbox"
                              id="isCloudVersion"
                              name="isCloudVersion"
                              checked={formik.values.isCloudVersion}
                              onChange={formik.handleChange}
                              className="form-check-input"
                            />
                            <Label check htmlFor="isCloudVersion" className="form-check-label">
                              Cloud Version
                            </Label>
                          </div>
                        </Col>

                        <Col lg={3} md={6} className="mb-2">
                          <div className="form-check">
                            <Input
                              type="checkbox"
                              id="isIRDVeriied"
                              name="isIRDVeriied"
                              checked={formik.values.isIRDVeriied}
                              onChange={formik.handleChange}
                              className="form-check-input"
                            />
                            <Label check htmlFor="isIRDVeriied" className="form-check-label">
                              IRD Verified
                            </Label>
                          </div>
                        </Col>

                        <Col lg={3} md={6} className="mb-2">
                          <div className="form-check">
                            <Input
                              type="checkbox"
                              id="isAbbreviated"
                              name="isAbbreviated"
                              checked={formik.values.isAbbreviated}
                              onChange={formik.handleChange}
                              className="form-check-input"
                            />
                            <Label check htmlFor="isAbbreviated" className="form-check-label">
                              Abbreviated
                            </Label>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <div className="text-end mt-4">
                    <Button
                      type="submit"
                      className="me-2"
                      color="success"
                      disabled={isSaving}
                    >
                      {isSaving ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Saving...
                        </>
                      ) : (
                        "Save"
                      )}
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => {
                        setIsCanceling(true);
                        navigate("/restrousers");
                      }}
                      disabled={isCanceling || isSaving}
                    >
                      {isCanceling ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Canceling...
                        </>
                      ) : (
                        "Cancel"
                      )}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default RestroUserInfoForm;